import { render, staticRenderFns } from "./deleteMember.vue?vue&type=template&id=5fe4e8a2"
import script from "./deleteMember.vue?vue&type=script&lang=js"
export * from "./deleteMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports